import { FC, useEffect, useState } from "react";
import { height, width } from "common";
import { useAppDispatch } from "hooks";
import { setPageTitle, setPageType } from "store";
import { EmbedType, PageType } from "types";
import { PowerBiServiceInstance } from "utilities";
import styles from "./styles.module.scss";
import { BackArrow, Popup } from "components";
import { CallCenter, CallCenterRalph } from "pages";
import { Button } from "@progress/kendo-react-buttons";

interface Props {
  pageType: PageType;
  pageTitle: string;
  id: string;
  name?: string;
  background?: "transparent" | "black" | "white";
  reportWithoutName?: boolean;
  removeBackArrow?: boolean;
}

export const Report: FC<Props> = ({
  id,
  pageType,
  name,
  pageTitle,
  background = "black",
  reportWithoutName = false,
  removeBackArrow = false,
}) => {
  const [reportLoading, setReportLoading] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPageType(pageType));
    dispatch(setPageTitle(pageTitle));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (reportLoading) {
      return;
    }

    setReportLoading(true);
    try {
      if (reportWithoutName) {
        PowerBiServiceInstance.load(id, {
          type: EmbedType.Report,
          elementId: id,
          height,
          width,
        });
      } else {
        if (name) {
          PowerBiServiceInstance.load(id, {
            type: EmbedType.Report,
            elementId: id,
            pageName: name,
            height,
            width,
          });
        } else {
          PowerBiServiceInstance.load(id, {
            type: EmbedType.Dashboard,
            elementId: id,
            height,
            width,
          });
        }
      }

      setReportLoading(false);
    } catch (error) {
      setReportLoading(false);
    }
  }, [reportLoading, pageType, name, id, reportWithoutName]);

  useEffect(() => {
    if (reportLoading || !name) {
      return;
    }
    PowerBiServiceInstance.switchPage(id, name);
  }, [reportLoading, name, id]);

  return (
    <div className={styles.container}>
      {removeBackArrow ? null : <BackArrow />}

      {id !== "" && (
        <div id={id} className={`${styles.report} ${styles[background]}`} />
      )}
    </div>
  );
};
